import(/* webpackMode: "eager", webpackExports: ["TimeZoneChangeDetector"] */ "/app/apps/web/src/app/[locale]/timezone-change-detector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/apps/web/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/app/apps/web/src/auth/session-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/[locale]/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/tailwindcss/tailwind.css");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/style.css");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/packages/ui/src/toaster.tsx");
